import { createApiCallAction } from '../apiCallAction';
import * as Api from '../../api/entities/talentPoolApi';
import { COMPANY_TALENT_POOLS_GET } from '../../constants/constants';

const getCompanyPoolsAction = createApiCallAction(COMPANY_TALENT_POOLS_GET, Api.getCompanyPools, {
  transformArgsToMeta: ([companyId]) => ({ companyId })
});
export const getCompanyPools = companyId => getCompanyPoolsAction(companyId);
